export default {
      id: "ic_photo-usage",
      viewBox: "0 0 36 31",
      url: "/" + "images/icons.3.109.2.svg#ic_photo-usage",
      toString: function () {
        return this.url;
      }
    }